export default __webpack_public_path__ + "static/media/d8.da105877.jpeg";